<div class="w-full px-4 sm:px-6 lg:px-8 pt-1.5 pb-1 sm:pt-4 bg-white" *ngIf="isStandalone">
  <app-breadcrum [data]="couponsBreadcrumbs"></app-breadcrum>
</div>
<div [class.px-4]="isStandalone" [class.sm:px-6]="isStandalone" [class.lg:px-8]="isStandalone">
<div
  class="flex flex-col items-start gap-6 w-full max-w-full px-2"
>
  <!-- Header -->
  <div class="flex flex-col items-start gap-6 w-full">
    <div class="flex flex-wrap items-center gap-1 whitespace-nowrap">
      <span class="text-black text-xl font-bold leading-8 whitespace-nowrap">
        Coupons & Offers
      </span>
      <span
        class="text-[#777] text-base font-medium leading-6 whitespace-nowrap"
      >
        -
      </span>
      <span class="text-[#777] text-lg font-medium leading-6 whitespace-nowrap">
        2 offers available
      </span>
    </div>

    <!-- Filters Row -->
    <div class="flex flex-wrap gap-2 w-full justify-between items-center">
      <!-- Left Filters -->
      <div class="flex flex-wrap items-center gap-2">
        <!-- Sort By Dropdown -->
        <div class="relative" #dropdownRef>
          <button
            (click)="toggleDropdown()"
            [ngClass]="{
              'border-blue-500': showDropdown,
              'border-gray-300': !showDropdown,
            }"
            class="flex items-center h-8 px-3 py-1 gap-1 rounded-lg text-sm font-medium text-black bg-white border focus:outline-none"
          >
            {{ selectedOption ? selectedOptionLabel : "Sort By" }}
            <svg
              class="ml-1"
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 20 20"
              fill="none"
            >
              <path
                d="M2 16L6 16M2 10L10 10M2 4L14 4"
                stroke="black"
                stroke-width="1.5"
                stroke-linecap="round"
              />
            </svg>
          </button>

          <!-- Desktop Dropdown -->
          <div
            *ngIf="showDropdown && !isMobileView"
            class="absolute z-10 mt-1 w-48 bg-white border border-gray-300 rounded-lg shadow-md divide-y divide-gray-200"
          >
            <label
              class="flex items-center gap-2 px-4 py-2 hover:bg-gray-100 cursor-pointer text-sm"
            >
              <input
                type="radio"
                name="sortOption"
                value="recent"
                [(ngModel)]="selectedOption"
                (change)="selectOption('recent')"
                class="text-blue-600 focus:ring-blue-500"
              />
              Recently Added
            </label>

            <label
              class="flex items-center gap-2 px-4 py-2 hover:bg-gray-100 cursor-pointer text-sm"
            >
              <input
                type="radio"
                name="sortOption"
                value="trending"
                [(ngModel)]="selectedOption"
                (change)="selectOption('trending')"
                class="text-blue-600 focus:ring-blue-500"
              />
              Trending
            </label>

            <label
              class="flex items-center gap-2 px-4 py-2 hover:bg-gray-100 cursor-pointer text-sm"
            >
              <input
                type="radio"
                name="sortOption"
                value="expiring"
                [(ngModel)]="selectedOption"
                (change)="selectOption('expiring')"
                class="text-blue-600 focus:ring-blue-500"
              />
              Expiring Soon
            </label>
          </div>
        </div>

        <!-- Mobile Bottom Sheet -->
        <div
          *ngIf="showDropdown && isMobileView"
          class="fixed inset-0 z-50 flex items-end bg-black bg-opacity-50"
        >
          <div class="w-full bg-white rounded-t-2xl shadow-lg animate-slide-up">
            <!-- Header -->
            <div class="flex justify-between items-center p-4 border-b">
              <h2 class="text-lg font-bold text-blue-900">Sort By</h2>
              <button (click)="toggleDropdown()">✕</button>
            </div>

            <!-- Options -->
            <div class="p-4 flex flex-col gap-3">
              <label class="flex items-center gap-2 cursor-pointer">
                <input
                  type="radio"
                  name="sortOptionMobile"
                  value="recent"
                  [(ngModel)]="selectedOption"
                  (change)="selectOption('recent')"
                  class="text-blue-600 focus:ring-blue-500"
                />
                Recently Added
              </label>

              <label class="flex items-center gap-2 cursor-pointer">
                <input
                  type="radio"
                  name="sortOptionMobile"
                  value="trending"
                  [(ngModel)]="selectedOption"
                  (change)="selectOption('trending')"
                  class="text-blue-600 focus:ring-blue-500"
                />
                Trending
              </label>

              <label class="flex items-center gap-2 cursor-pointer">
                <input
                  type="radio"
                  name="sortOptionMobile"
                  value="expiring"
                  [(ngModel)]="selectedOption"
                  (change)="selectOption('expiring')"
                  class="text-blue-600 focus:ring-blue-500"
                />
                Expiring Soon
              </label>
            </div>
          </div>
        </div>

        <!-- Categories Dropdown -->
        <div class="relative" #categoryDropdownRef>
          <button
            (click)="toggleCategoryDropdown()"
            [ngClass]="{
              'border-blue-500': showCategoryDropdown,
              'border-gray-300': !showCategoryDropdown,
            }"
            class="flex items-center h-8 px-3 py-1 gap-1 rounded-lg border text-sm font-medium text-black bg-white focus:outline-none"
          >
            {{ selectedCategory ? selectedCategory : "Categories" }}
            <svg
              class="ml-1"
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 20 20"
              fill="none"
            >
              <path
                d="M5 7L10 12L15 7"
                stroke="black"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>

          <!-- Desktop dropdown with radio buttons -->
          <div
            *ngIf="showCategoryDropdown && !isMobileView"
            class="absolute z-10 mt-1 w-56 bg-white border border-gray-300 rounded-lg shadow-md divide-y divide-gray-200"
          >
            <label
              class="flex items-center gap-2 px-4 py-2 hover:bg-gray-100 cursor-pointer text-sm"
              *ngFor="let category of categories"
            >
              <input
                type="radio"
                name="category"
                [value]="category"
                [(ngModel)]="selectedCategory"
                (change)="selectCategory(category)"
                class="text-blue-600 focus:ring-blue-500"
              />
              {{ category }}
            </label>
          </div>
        </div>

        <!-- Mobile Bottom Sheet -->
        <div
          *ngIf="showCategoryDropdown && isMobileView"
          class="fixed inset-0 z-50 flex items-end bg-black bg-opacity-50"
        >
          <div class="w-full bg-white rounded-t-2xl shadow-lg animate-slide-up">
            <!-- Header -->
            <div class="flex justify-between items-center p-4 border-b">
              <h2 class="text-lg font-bold text-blue-900">Categories</h2>
              <button (click)="toggleCategoryDropdown()">✕</button>
            </div>

            <!-- Options -->
            <div class="p-4 flex flex-col gap-3">
              <label
                class="flex items-center gap-2 cursor-pointer"
                *ngFor="let category of categories"
              >
                <input
                  type="radio"
                  name="categoryMobile"
                  [value]="category"
                  [(ngModel)]="selectedCategory"
                  (change)="selectCategory(category)"
                  class="text-blue-600 focus:ring-blue-500"
                />
                {{ category }}
              </label>
            </div>
          </div>
        </div>

        <!-- Seller Dropdown -->
        <div class="relative" #sellerDropdownRef>
          <button
            (click)="toggleSellerDropdown()"
            [ngClass]="{
              'border-blue-500': showSellerDropdown,
              'border-gray-300': !showSellerDropdown,
            }"
            class="flex items-center h-8 px-3 py-1 gap-1 rounded-lg border text-sm font-medium text-black bg-white focus:outline-none"
          >
            Seller
            <svg
              class="ml-1"
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 20 20"
              fill="none"
            >
              <path
                d="M5 7L10 12L15 7"
                stroke="black"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>

          <!-- Desktop Dropdown with Radio Buttons -->
          <div
            *ngIf="showSellerDropdown && !isMobileView"
            class="absolute z-10 mt-1 w-48 bg-white border border-gray-300 rounded-lg shadow-md divide-y divide-gray-200"
          >
            <label
              class="flex items-center gap-2 px-4 py-2 hover:bg-gray-100 cursor-pointer text-sm"
            >
              <input
                type="radio"
                name="seller"
                value="Seller A"
                [(ngModel)]="selectedSeller"
                (change)="selectSeller('Seller A')"
                class="text-blue-600 focus:ring-blue-500"
              />
              Seller A
            </label>

            <label
              class="flex items-center gap-2 px-4 py-2 hover:bg-gray-100 cursor-pointer text-sm"
            >
              <input
                type="radio"
                name="seller"
                value="Seller B"
                [(ngModel)]="selectedSeller"
                (change)="selectSeller('Seller B')"
                class="text-blue-600 focus:ring-blue-500"
              />
              Seller B
            </label>
          </div>
        </div>

        <!-- Mobile Bottom Sheet -->
        <div
          *ngIf="showSellerDropdown && isMobileView"
          class="fixed inset-0 z-50 flex items-end bg-black bg-opacity-50"
        >
          <div class="w-full bg-white rounded-t-2xl shadow-lg animate-slide-up">
            <!-- Header -->
            <div class="flex justify-between items-center p-4 border-b">
              <h2 class="text-lg font-bold text-blue-900">Seller</h2>
              <button (click)="toggleSellerDropdown()">✕</button>
            </div>

            <!-- Options -->
            <div class="p-4 flex flex-col gap-3">
              <label class="flex items-center gap-2 cursor-pointer">
                <input
                  type="radio"
                  name="seller-mobile"
                  value="Seller A"
                  [(ngModel)]="selectedSeller"
                  (change)="selectSeller('Seller A')"
                  class="text-blue-600 focus:ring-blue-500"
                />
                Seller A
              </label>

              <label class="flex items-center gap-2 cursor-pointer">
                <input
                  type="radio"
                  name="seller-mobile"
                  value="Seller B"
                  [(ngModel)]="selectedSeller"
                  (change)="selectSeller('Seller B')"
                  class="text-blue-600 focus:ring-blue-500"
                />
                Seller B
              </label>
            </div>
          </div>
        </div>
      </div>

      <!-- Search -->
      <div class="w-full sm:w-[232px] mt-2 sm:mt-0">
        <div
          class="flex h-8 p-2 justify-between items-center rounded-md border border-gray-300 w-full"
        >
          <input
            placeholder="Search by name or code"
            class="text-gray-500 text-sm font-medium w-full focus:outline-none"
          />
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
          >
            <path
              d="M13.8807 13.8807C16.4842 11.2772 16.4842 7.05612 13.8807 4.45262C11.2772 1.84913 7.05612 1.84913 4.45262 4.45262C1.84913 7.05612 1.84913 11.2772 4.45262 13.8807C7.05612 16.4842 11.2772 16.4842 13.8807 13.8807ZM13.8807 13.8807L17.5 17.5"
              stroke="#777777"
              stroke-width="1.67"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
      </div>
    </div>
  </div>

  <!-- Offers List -->
  <div class="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-4 w-full">
    <div
      *ngFor="let item of Container_arr"
      class="flex flex-col w-full p-4 items-start gap-2 rounded-xl border border-gray-300 custom-before"
    >
      <!-- Coupon Header -->
      <div class="flex justify-between items-center w-full">
        <div
          class="flex items-center gap-1 pl-2 rounded-md border border-[#307FE1]"
        >
          <div class="text-[#307FE1] text-sm font-bold">
            {{ item.code }}
          </div>
          <div
            class="flex justify-center items-center w-7 h-7 rounded-r-md bg-[#307FE1]"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
            >
              <path
                d="M6.66667 2.5H12.5C15.2614 2.5 17.5 4.73858 17.5 7.5V13.3333M11.6667 5.83333H5C3.61929 5.83333 2.5 6.95262 2.5 8.33333V15C2.5 16.3807 3.61929 17.5 5 17.5H11.6667C13.0474 17.5 14.1667 16.3807 14.1667 15V8.33333C14.1667 6.95262 13.0474 5.83333 11.6667 5.83333Z"
                stroke="white"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        </div>
        <div class="text-[#307FE1] text-sm font-bold underline cursor-pointer">
          T&C
        </div>
      </div>

      <!-- Description -->
      <div class="text-[#0A0A5F] text-base font-bold">
        {{ item.description }}
      </div>

      <!-- Validity -->
      <div class="flex items-center gap-2">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M9.99996 5.83464V9.82871C9.99996 9.93922 10.0439 10.0452 10.122 10.1233L11.6666 11.668M9.99996 18.3346C5.39759 18.3346 1.66663 14.6037 1.66663 10.0013C1.66663 5.39893 5.39759 1.66797 9.99996 1.66797C14.6023 1.66797 18.3333 5.39893 18.3333 10.0013C18.3333 14.6037 14.6023 18.3346 9.99996 18.3346Z"
            [attr.stroke]="item.isActive ? 'black' : '#E30613'"
            stroke-width="1.5"
            stroke-linecap="round"
          />
        </svg>
        <span *ngIf="!item.isActive" class="text-[#E30613] text-sm font-medium">
          {{ item.preoffererMsg }}
        </span>
        <span *ngIf="item.isActive" class="text-black text-sm font-bold">
          Valid till {{ item.expiryDate }}
        </span>
      </div>

      <!-- View Products -->
      <div
        class="flex items-center gap-1 text-[#307FE1] text-sm font-bold cursor-pointer"
      >
        View Products
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M9 6L14.2929 11.2929C14.6834 11.6834 14.6834 12.3166 14.2929 12.7071L9 18"
            stroke="#307FE1"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
    </div>
  </div>
</div>

</div>